import { Pipe } from '@angular/core';

import type { PipeTransform } from '@angular/core';

@Pipe({ name: 'kpSplit' })
export class SplitPipe implements PipeTransform {
  transform(value?: string): Array<string> {
    return value ? value.split(',') : [];
  }
}
